<template>
  <!-- 
      TODO: Por algum motivo a rota não está retornando os status, resolver.
   -->
  <div>
      <v-chip close close-icon="mdi-help-circle" :class="status.Cor" @click:close="[showHelpStatusDialog = true]" dark>
          {{ status.Titulo }}
      </v-chip>
      <v-dialog width="80%" v-model="showHelpStatusDialog">
          <v-card>
              <v-card-title>
                  O que significa esse status?
              </v-card-title>
              <v-card-text>
                  <v-list dense>
                      <v-list-item v-for="status in statusProcesso" :key="status.index">
                        <v-list-item-icon>
                            <v-chip style="min-width: 100px !important; text-align: center !important;" :class="status.color" dark>
                                {{ status.title }}
                            </v-chip>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>
                                <h3>{{ status.description}}</h3>
                            </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                  </v-list>
              </v-card-text>
          </v-card>
      </v-dialog>
  </div>
</template>

<script>
export default {
    name: 'StatusProcesso',
    props: {
        status: {
            type: Object
        }
    },
    data: () => ({
        showHelpStatusDialog: false,
        statusProcesso: {
            1: { 
                title: 'Agendado',
                color: 'blue darken-1',
                description: ' Apenas agendado, sem nenhuma execução ou certificação efetuada.'
            },
            2: { 
                title: 'Executado',
                color: 'cyan darken-1',
                description: 'Foi informada a quantidade executada no atendimento.'
            },
            3: { 
                title: 'Lançamento',
                color: 'purple darken-1',
                description: 'As certificações e o processo de anexo das evidências estão sendo providenciados.'
            },
            4: { 
                title: 'Produção',
                color: 'pink darken-1',
                description: 'Todas as certificações foram efetuadas, o processo está no Núcleo para revisão e envio para o faturamento.'
            },
            5: { 
                title: 'A faturar',
                color: 'teal darken-1',
                description: 'Está no faturamento, porém ainda não foi faturado.'
            },
            6: { 
                title: 'Faturado',
                color: 'green darken-1',
                description: 'Processo faturado.'
            },
            7: { 
                title: 'Pago',
                color: 'blue darken-1',
                description: 'A baixa foi efetuada, pagamento efetuado.'
            },
            8: {
                title: 'Vencido',
                color: 'red darken-1',
                description: 'Processo vencido.'
            }
        }
    }),
    methods: {
        getStatus () {
            this.axios.get('agendamentos/status-processo').then( res => {
                this.statusProcesso = res.data
            })
        }
    }
}
</script>

<style>

</style>